var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_143_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.0001,
    cy: 15.0001,
    r: 15.0001,
    fill: "#01AFFD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7755 12.031C19.0191 11.3228 18.0376 10.9346 16.9963 10.9355C15.1223 10.9371 13.5045 12.222 13.0578 14.0044C13.0253 14.1342 12.9097 14.2258 12.776 14.2258H11.3896C11.2082 14.2258 11.0704 14.0611 11.1039 13.8828C11.6274 11.103 14.0681 9 17 9C18.6076 9 20.0675 9.63232 21.1447 10.6617L22.0088 9.79766C22.3746 9.43188 23 9.69094 23 10.2083V13.4516C23 13.7723 22.74 14.0323 22.4194 14.0323H19.176C18.6587 14.0323 18.3996 13.4068 18.7654 13.041L19.7755 12.031V12.031ZM11.5806 15.9677H14.824C15.3413 15.9677 15.6004 16.5932 15.2346 16.959L14.2245 17.9691C14.9809 18.6773 15.9625 19.0655 17.0038 19.0645C18.8768 19.0628 20.4953 17.7788 20.9422 15.9956C20.9747 15.8659 21.0903 15.7742 21.224 15.7742H22.6104C22.7918 15.7742 22.9296 15.9389 22.8961 16.1172C22.3726 18.897 19.9319 21 17 21C15.3924 21 13.9325 20.3677 12.8553 19.3383L11.9912 20.2023C11.6254 20.5681 11 20.3091 11 19.7917V16.5484C11 16.2277 11.26 15.9677 11.5806 15.9677Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_143_2",
    x: 0,
    y: 0,
    width: 34.0001,
    height: 34.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_143_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.0780fc1da5baeb8f1028de5279beff66.svg";
export { ForwardRef as ReactComponent };